"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var interpreter_utils_1 = require("../../../interpreter-utils");
var condition_field_reader_1 = require("./condition-field-reader");
// tslint:disable-next-line:no-any
function isPlainConditionValue(toCheck) {
    return lodash_1.isNumber(toCheck) || lodash_1.isString(toCheck) || lodash_1.isBoolean(toCheck);
}
exports.isPlainConditionValue = isPlainConditionValue;
function getEntityValue(context, strValueParse) {
    var entity = interpreter_utils_1.getRequiredProperty(context, 'entity');
    var _a = /^entity\.([^.]+)\.?(.*)$/g.exec(strValueParse), parameter = _a[1], postfix = _a[2];
    var entityField = condition_field_reader_1.ConditionFieldReader.getEntityFieldValue(entity, parameter);
    if (entityField && postfix !== '') {
        entityField = parseEntityField(entityField, postfix);
    }
    if (lodash_1.isDate(entityField)) {
        return entityField.getTime() - entityField.getSeconds() * 1000;
    }
    return entityField;
}
exports.getEntityValue = getEntityValue;
function getQueryParamValue(context, strValueParse) {
    var _a = /^queryParams\.([^.]+)\.?(.*)$/g.exec(strValueParse), parameter = _a[1], postfix = _a[2];
    var queryParams = interpreter_utils_1.getRequiredProperty(context, 'queryParams');
    var entityField = condition_field_reader_1.ConditionFieldReader.getEntityFieldValue(queryParams, parameter);
    if (entityField && postfix !== '') {
        entityField = parseEntityField(entityField, postfix);
    }
    return entityField;
}
exports.getQueryParamValue = getQueryParamValue;
function getItemValue(context, strValueParse) {
    var _a = /^item\.([^.]+)\.?(.*)$/g.exec(strValueParse), parameter = _a[1], postfix = _a[2];
    var item = interpreter_utils_1.getRequiredProperty(context, 'item');
    var itemField = condition_field_reader_1.ConditionFieldReader.getEntityFieldValue(item, parameter);
    if (itemField && postfix !== '') {
        itemField = parseEntityField(itemField, postfix);
    }
    return itemField;
}
exports.getItemValue = getItemValue;
function parseEntityField(obj, path) {
    var _a = /^([^.]+)\.?(.*)$/g.exec(path), parameter = _a[1], postfix = _a[2];
    var currValue = condition_field_reader_1.ConditionFieldReader.getEntityFieldValue(obj, parameter);
    if (!currValue) {
        return undefined;
    }
    else if (postfix !== '') {
        return parseEntityField(currValue, postfix);
    }
    else {
        return currValue;
    }
}
//# sourceMappingURL=condition-utils.js.map